import { useCallback } from 'react';
import { v1 as uuid } from 'uuid';
import commonApis from '@/apis/commonApis';

export enum bulkWhitelistLogEventsEnum {
  visitTTCX = 4,
  loginTTCX = 5,
  joinTTCX = 6,
  viewTerms = 7,
  signTerms = 8,
  clickCreateProject = 9,
  submitBrief = 10,
  register = 100
}

export function getDeviceId() {
  let deviceId = localStorage.getItem('ttcx_device_id');

  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem('ttcx_device_id', deviceId);
  }

  return deviceId;
}

export function useLogUserViewBehaviors() {
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  const logger = useCallback((params: { event_type: bulkWhitelistLogEventsEnum; invite_code?: string }) => {
    const _params = {
      device_id: getDeviceId(),
      operating_system: isMobile ? 'mobile' : 'pc',
      ...params
    };
    commonApis.eventTracking(_params);
    console.log(_params);
  }, []);
  return logger;
}
